(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("baORH", function(module, exports) {

$parcel$export(module.exports, "Types", function () { return $8228159cc212fd1b$export$4624c240901a6889; });
$parcel$export(module.exports, "IFrame", function () { return $8228159cc212fd1b$export$b32b5f1ee4493319; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $j18K6 = parcelRequire("j18K6");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");
function $8228159cc212fd1b$var$fromString(kind) {
    switch(kind){
        case "category-card":
            return "category-card";
        case "clp-quick-categories":
            return "clp-quick-categories";
        case "first-card":
            return "first-card";
        case "menubar":
            return "menubar";
        case "menubar-item":
            return "menubar-item";
        case "navbar-item":
            return "navbar-item";
        case "quickview-card":
            return "quickview-card";
        case "section":
            return "section";
        case "section-title":
            return "section-title";
        default:
            return "unknown";
    }
}
function $8228159cc212fd1b$var$toString(kind) {
    return kind;
}
var $8228159cc212fd1b$var$Kind = {
    fromString: $8228159cc212fd1b$var$fromString,
    toString: $8228159cc212fd1b$var$toString
};
function $8228159cc212fd1b$var$fromString$1(theme) {
    switch(theme){
        case "blue":
            return "blue";
        case "purple":
            return "purple";
        default:
            return "blue";
    }
}
function $8228159cc212fd1b$var$toString$1(theme) {
    return theme;
}
var $8228159cc212fd1b$var$Theme = {
    fromString: $8228159cc212fd1b$var$fromString$1,
    toString: $8228159cc212fd1b$var$toString$1
};
function $8228159cc212fd1b$var$toString$2(command) {
    switch(command){
        case /* Ready */ 0:
            return "SmartNav.In.ready";
        case /* Destroyed */ 1:
            return "SmartNav.In.destroyed";
        case /* RefreshConfig */ 2:
            return "SmartNav.In.refreshConfig";
        case /* Open */ 3:
            return "SmartNav.In.open";
        case /* ScrollTo */ 4:
            return "SmartNav.In.scrollTo";
        case /* FocusOnSection */ 5:
            return "SmartNav.In.focusOnSection";
        case /* FocusOnCard */ 6:
            return "SmartNav.In.focusOnCard";
        case /* Select */ 7:
            return "SmartNav.In.select";
        case /* Unselect */ 8:
            return "SmartNav.In.unselect";
        case /* Hover */ 9:
            return "SmartNav.In.hover";
        case /* Unhover */ 10:
            return "SmartNav.In.unhover";
        case /* InspectOn */ 11:
            return "SmartNav.In.inspectModeOn";
        case /* InspectOff */ 12:
            return "SmartNav.In.inspectModeOff";
    }
}
var $8228159cc212fd1b$var$IncomingCommand = {
    toString: $8228159cc212fd1b$var$toString$2
};
function $8228159cc212fd1b$var$toString$3(command) {
    switch(command){
        case /* Ready */ 0:
            return "SmartNav.Out.ready";
        case /* Destroyed */ 1:
            return "SmartNav.Out.destroyed";
        case /* RefreshConfig */ 2:
            return "SmartNav.Out.refreshConfig";
        case /* Open */ 3:
            return "SmartNav.Out.open";
        case /* ScrollTo */ 4:
            return "SmartNav.Out.scrollTo";
        case /* FocusOnSection */ 5:
            return "SmartNav.Out.focusOnSection";
        case /* FocusOnCard */ 6:
            return "SmartNav.Out.focusOnCard";
        case /* Select */ 7:
            return "SmartNav.Out.select";
        case /* Unselect */ 8:
            return "SmartNav.Out.unselect";
        case /* Hover */ 9:
            return "SmartNav.Out.hover";
        case /* Unhover */ 10:
            return "SmartNav.Out.unhover";
        case /* InspectOn */ 11:
            return "SmartNav.Out.inspectModeOn";
        case /* InspectOff */ 12:
            return "SmartNav.Out.inspectModeOff";
    }
}
var $8228159cc212fd1b$var$OutgoingCommand = {
    toString: $8228159cc212fd1b$var$toString$3
};
var $8228159cc212fd1b$var$InternalCommandDoNotUse = {
    IncomingCommand: $8228159cc212fd1b$var$IncomingCommand,
    OutgoingCommand: $8228159cc212fd1b$var$OutgoingCommand
};
function $8228159cc212fd1b$var$fromDomRect(rect) {
    var top = rect.top;
    var bottom = rect.bottom;
    var left = rect.left;
    var right = rect.right;
    var width = rect.width;
    var height = rect.height;
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height
    };
}
var $8228159cc212fd1b$var$Rect = {
    fromDomRect: $8228159cc212fd1b$var$fromDomRect
};
var $8228159cc212fd1b$var$Item = {};
var $8228159cc212fd1b$export$4624c240901a6889 = {
    Kind: $8228159cc212fd1b$var$Kind,
    Theme: $8228159cc212fd1b$var$Theme,
    InternalCommandDoNotUse: $8228159cc212fd1b$var$InternalCommandDoNotUse,
    Rect: $8228159cc212fd1b$var$Rect,
    Item: $8228159cc212fd1b$var$Item
};
var $8228159cc212fd1b$var$OutCommand = {
    toString: $8228159cc212fd1b$var$toString$3
};
var $8228159cc212fd1b$var$InCommand = {
    toString: $8228159cc212fd1b$var$toString$2
};
function $8228159cc212fd1b$var$useCommandReceiver(debugOpt, command, fn, dependencies) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    $g85JO.useEffect(function() {
        var command$1 = $8228159cc212fd1b$var$toString$2(command);
        var func = function func(arg) {
            if (debug) console.log("[IFrame] recieved command " + command$1, arg);
            return $iv6Yc._1(fn, arg);
        };
        var register = $j18K6.ParentWindow.expose1(command$1, func);
        return function(param) {
            $iv6Yc._1(register.close, undefined);
        };
    }, dependencies);
}
function $8228159cc212fd1b$var$sendCommand0(debugOpt, command) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    if (debug) console.log("[IFrame] send command: ", $8228159cc212fd1b$var$toString$3(command));
    $j18K6.ParentWindow.caller0($8228159cc212fd1b$var$toString$3(command))(undefined);
}
function $8228159cc212fd1b$var$sendCommand1(debugOpt, command, arg) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    if (debug) console.log("[IFrame] send command: ", $8228159cc212fd1b$var$toString$3(command), arg);
    $j18K6.ParentWindow.caller1($8228159cc212fd1b$var$toString$3(command))(arg);
}
function $8228159cc212fd1b$var$sendCommand2(debugOpt, command, arg1, arg2) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    if (debug) console.log("[IFrame] send command: ", $8228159cc212fd1b$var$toString$3(command), arg1, arg2);
    $j18K6.ParentWindow.caller2($8228159cc212fd1b$var$toString$3(command))(arg1, arg2);
}
var $8228159cc212fd1b$export$b32b5f1ee4493319 = {
    OutCommand: $8228159cc212fd1b$var$OutCommand,
    InCommand: $8228159cc212fd1b$var$InCommand,
    useCommandReceiver: $8228159cc212fd1b$var$useCommandReceiver,
    sendCommand0: $8228159cc212fd1b$var$sendCommand0,
    sendCommand1: $8228159cc212fd1b$var$sendCommand1,
    sendCommand2: $8228159cc212fd1b$var$sendCommand2
};
var $8228159cc212fd1b$var$OutCommand$1 = {
    toString: $8228159cc212fd1b$var$toString$2
};
var $8228159cc212fd1b$var$InCommand$1 = {
    toString: $8228159cc212fd1b$var$toString$3
};
function $8228159cc212fd1b$var$useCommandReceiver$1(debugOpt, command, fn, dependencies) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    $g85JO.useEffect(function() {
        var command$1 = $8228159cc212fd1b$var$toString$3(command);
        var func = function func(arg) {
            if (debug) console.log("[ParentWindow] recieved command " + command$1, arg);
            return $iv6Yc._1(fn, arg);
        };
        var register = $j18K6.ParentWindow.expose1(command$1, func);
        return function(param) {
            $iv6Yc._1(register.close, undefined);
        };
    }, dependencies);
}
function $8228159cc212fd1b$var$sendCommand0$1(debugOpt, command) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    if (debug) console.log("[ParentWindow] send command: ", $8228159cc212fd1b$var$toString$2(command));
    $j18K6.ChildIFrames.caller0($8228159cc212fd1b$var$toString$2(command))(undefined);
}
function $8228159cc212fd1b$var$sendCommand1$1(debugOpt, command, arg) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    if (debug) console.log("[ParentWindow] send command: ", $8228159cc212fd1b$var$toString$2(command), arg);
    $j18K6.ChildIFrames.caller1($8228159cc212fd1b$var$toString$2(command))(arg);
}
function $8228159cc212fd1b$var$sendCommand2$1(debugOpt, command, arg1, arg2) {
    var debug = debugOpt !== undefined ? debugOpt : false;
    if (debug) console.log("[ParentWindow] send command: ", $8228159cc212fd1b$var$toString$2(command), arg1, arg2);
    $j18K6.ChildIFrames.caller2($8228159cc212fd1b$var$toString$2(command))(arg1, arg2);
}
var $8228159cc212fd1b$export$9f87c6d2fc629dfe = {
    OutCommand: $8228159cc212fd1b$var$OutCommand$1,
    InCommand: $8228159cc212fd1b$var$InCommand$1,
    useCommandReceiver: $8228159cc212fd1b$var$useCommandReceiver$1,
    sendCommand0: $8228159cc212fd1b$var$sendCommand0$1,
    sendCommand1: $8228159cc212fd1b$var$sendCommand1$1,
    sendCommand2: $8228159cc212fd1b$var$sendCommand2$1
};
 /* RPC Not a pure module */ 
});
parcelRegister("j18K6", function(module, exports) {

$parcel$export(module.exports, "ParentWindow", function () { return $dd84e46d1ad8b967$export$9f87c6d2fc629dfe; });
$parcel$export(module.exports, "ChildIFrames", function () { return $dd84e46d1ad8b967$export$1c88a198e6582971; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");

var $da91V = parcelRequire("da91V");
var $dd84e46d1ad8b967$var$options = {
    postMessage: function postMessage(data, origin) {
        window.parent.postMessage(data, origin);
    }
};
function $dd84e46d1ad8b967$var$expose1(funcName, impl) {
    return $da91V.expose(funcName, impl, $dd84e46d1ad8b967$var$options);
}
function $dd84e46d1ad8b967$var$expose0(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._1(impl, undefined);
    }, $dd84e46d1ad8b967$var$options);
}
function $dd84e46d1ad8b967$var$expose2(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._2(impl, param[0], param[1]);
    }, $dd84e46d1ad8b967$var$options);
}
function $dd84e46d1ad8b967$var$expose3(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._3(impl, param[0], param[1], param[2]);
    }, $dd84e46d1ad8b967$var$options);
}
function $dd84e46d1ad8b967$var$caller1(funcName) {
    var fn1 = $da91V.caller(funcName, $dd84e46d1ad8b967$var$options);
    return function(a) {
        return fn1(a);
    };
}
function $dd84e46d1ad8b967$var$caller0(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1(funcName);
    return function(param) {
        return $iv6Yc._1(fn1, []);
    };
}
function $dd84e46d1ad8b967$var$caller2(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1(funcName);
    return function(a, b) {
        return $iv6Yc._1(fn1, [
            a,
            b
        ]);
    };
}
function $dd84e46d1ad8b967$var$caller3(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1(funcName);
    return function(a, b, c) {
        return $iv6Yc._1(fn1, [
            a,
            b,
            c
        ]);
    };
}
var $dd84e46d1ad8b967$export$9f87c6d2fc629dfe = {
    options: $dd84e46d1ad8b967$var$options,
    expose1: $dd84e46d1ad8b967$var$expose1,
    expose0: $dd84e46d1ad8b967$var$expose0,
    expose2: $dd84e46d1ad8b967$var$expose2,
    expose3: $dd84e46d1ad8b967$var$expose3,
    caller1: $dd84e46d1ad8b967$var$caller1,
    caller0: $dd84e46d1ad8b967$var$caller0,
    caller2: $dd84e46d1ad8b967$var$caller2,
    caller3: $dd84e46d1ad8b967$var$caller3
};
var $dd84e46d1ad8b967$var$options$1 = {
    postMessage: function postMessage(data, origin) {
        $i7mYY.map(Array.prototype.slice.call(document.querySelectorAll("iframe")), function(el) {
            el.contentWindow.postMessage(data, origin);
        });
    }
};
function $dd84e46d1ad8b967$var$expose1$1(funcName, impl) {
    return $da91V.expose(funcName, impl, $dd84e46d1ad8b967$var$options$1);
}
function $dd84e46d1ad8b967$var$expose0$1(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._1(impl, undefined);
    }, $dd84e46d1ad8b967$var$options$1);
}
function $dd84e46d1ad8b967$var$expose2$1(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._2(impl, param[0], param[1]);
    }, $dd84e46d1ad8b967$var$options$1);
}
function $dd84e46d1ad8b967$var$expose3$1(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._3(impl, param[0], param[1], param[2]);
    }, $dd84e46d1ad8b967$var$options$1);
}
function $dd84e46d1ad8b967$var$caller1$1(funcName) {
    var fn1 = $da91V.caller(funcName, $dd84e46d1ad8b967$var$options$1);
    return function(a) {
        return fn1(a);
    };
}
function $dd84e46d1ad8b967$var$caller0$1(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1$1(funcName);
    return function(param) {
        return $iv6Yc._1(fn1, []);
    };
}
function $dd84e46d1ad8b967$var$caller2$1(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1$1(funcName);
    return function(a, b) {
        return $iv6Yc._1(fn1, [
            a,
            b
        ]);
    };
}
function $dd84e46d1ad8b967$var$caller3$1(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1$1(funcName);
    return function(a, b, c) {
        return $iv6Yc._1(fn1, [
            a,
            b,
            c
        ]);
    };
}
var $dd84e46d1ad8b967$export$1c88a198e6582971 = {
    options: $dd84e46d1ad8b967$var$options$1,
    expose1: $dd84e46d1ad8b967$var$expose1$1,
    expose0: $dd84e46d1ad8b967$var$expose0$1,
    expose2: $dd84e46d1ad8b967$var$expose2$1,
    expose3: $dd84e46d1ad8b967$var$expose3$1,
    caller1: $dd84e46d1ad8b967$var$caller1$1,
    caller0: $dd84e46d1ad8b967$var$caller0$1,
    caller2: $dd84e46d1ad8b967$var$caller2$1,
    caller3: $dd84e46d1ad8b967$var$caller3$1
};
var $dd84e46d1ad8b967$var$options$2 = {
    postMessage: function postMessage(data, origin) {
        window.opener.postMessage(data, origin);
    }
};
function $dd84e46d1ad8b967$var$expose1$2(funcName, impl) {
    return $da91V.expose(funcName, impl, $dd84e46d1ad8b967$var$options$2);
}
function $dd84e46d1ad8b967$var$expose0$2(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._1(impl, undefined);
    }, $dd84e46d1ad8b967$var$options$2);
}
function $dd84e46d1ad8b967$var$expose2$2(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._2(impl, param[0], param[1]);
    }, $dd84e46d1ad8b967$var$options$2);
}
function $dd84e46d1ad8b967$var$expose3$2(funcName, impl) {
    return $da91V.expose(funcName, function(param) {
        return $iv6Yc._3(impl, param[0], param[1], param[2]);
    }, $dd84e46d1ad8b967$var$options$2);
}
function $dd84e46d1ad8b967$var$caller1$2(funcName) {
    var fn1 = $da91V.caller(funcName, $dd84e46d1ad8b967$var$options$2);
    return function(a) {
        return fn1(a);
    };
}
function $dd84e46d1ad8b967$var$caller0$2(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1$2(funcName);
    return function(param) {
        return $iv6Yc._1(fn1, []);
    };
}
function $dd84e46d1ad8b967$var$caller2$2(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1$2(funcName);
    return function(a, b) {
        return $iv6Yc._1(fn1, [
            a,
            b
        ]);
    };
}
function $dd84e46d1ad8b967$var$caller3$2(funcName) {
    var fn1 = $dd84e46d1ad8b967$var$caller1$2(funcName);
    return function(a, b, c) {
        return $iv6Yc._1(fn1, [
            a,
            b,
            c
        ]);
    };
}
var $dd84e46d1ad8b967$export$5d3e9d671cd92084 = {
    options: $dd84e46d1ad8b967$var$options$2,
    expose1: $dd84e46d1ad8b967$var$expose1$2,
    expose0: $dd84e46d1ad8b967$var$expose0$2,
    expose2: $dd84e46d1ad8b967$var$expose2$2,
    expose3: $dd84e46d1ad8b967$var$expose3$2,
    caller1: $dd84e46d1ad8b967$var$caller1$2,
    caller0: $dd84e46d1ad8b967$var$caller0$2,
    caller2: $dd84e46d1ad8b967$var$caller2$2,
    caller3: $dd84e46d1ad8b967$var$caller3$2
};
 /* postmsg-rpc Not a pure module */ 
});
parcelRegister("da91V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $46yxG = parcelRequire("46yxG");
Object.defineProperty(module.exports, "caller", {
    enumerable: true,
    get: function get() {
        return $995336b483605e05$var$_interopRequireDefault($46yxG).default;
    }
});
Object.defineProperty(module.exports, "call", {
    enumerable: true,
    get: function get() {
        return $46yxG.call;
    }
});

var $fg5PJ = parcelRequire("fg5PJ");
Object.defineProperty(module.exports, "expose", {
    enumerable: true,
    get: function get() {
        return $995336b483605e05$var$_interopRequireDefault($fg5PJ).default;
    }
});
function $995336b483605e05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("46yxG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fd284565b49ee79$var$caller;
module.exports.call = $2fd284565b49ee79$var$call;

var $7M5pn = parcelRequire("7M5pn");
var $2fd284565b49ee79$var$_shortid2 = $2fd284565b49ee79$var$_interopRequireDefault($7M5pn);
function $2fd284565b49ee79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2fd284565b49ee79$var$caller(funcName, opts) {
    opts = opts || {};
    var addListener = opts.addListener || window.addEventListener;
    var removeListener = opts.removeListener || window.removeEventListener;
    var postMessage = opts.postMessage || window.postMessage;
    var targetOrigin = opts.targetOrigin || "*";
    var getMessageData = opts.getMessageData || function(event) {
        return event.data;
    };
    return function() {
        var msg = {
            sender: "postmsg-rpc/client",
            id: (0, $2fd284565b49ee79$var$_shortid2.default)(),
            func: funcName,
            args: Array.from(arguments)
        };
        var cancel = void 0;
        var response = new Promise(function(resolve, reject) {
            var handler = function handler() {
                var data = getMessageData.apply(null, arguments);
                if (!data) return;
                if (data.sender !== "postmsg-rpc/server" || data.id !== msg.id) return;
                removeListener("message", handler);
                if (data.err) {
                    var err = new Error("Unexpected error calling " + funcName);
                    Object.assign(err, data.err);
                    return reject(err);
                }
                resolve(data.res);
            };
            cancel = function cancel() {
                removeListener("message", handler);
                var err = new Error("Canceled call to " + funcName);
                err.isCanceled = true;
                reject(err);
            };
            addListener("message", handler);
            postMessage(msg, targetOrigin);
        });
        response.cancel = function() {
            return cancel();
        };
        return response;
    };
}
function $2fd284565b49ee79$var$call(funcName) {
    return $2fd284565b49ee79$var$caller(funcName).apply(null, [].slice.call(arguments, 1));
}

});
parcelRegister("7M5pn", function(module, exports) {
"use strict";

module.exports = (parcelRequire("50iPt"));

});
parcelRegister("50iPt", function(module, exports) {
"use strict";

var $lg2XI = parcelRequire("lg2XI");

var $b39uO = parcelRequire("b39uO");

var $73CeR = parcelRequire("73CeR");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var $3a4b8eeb6e37bdc4$var$clusterWorkerId = (parcelRequire("bo6AG")) || 0;
/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */ function $3a4b8eeb6e37bdc4$var$seed(seedValue) {
    $lg2XI.seed(seedValue);
    return module.exports;
}
/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */ function $3a4b8eeb6e37bdc4$var$worker(workerId) {
    $3a4b8eeb6e37bdc4$var$clusterWorkerId = workerId;
    return module.exports;
}
/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */ function $3a4b8eeb6e37bdc4$var$characters(newCharacters) {
    if (newCharacters !== undefined) $lg2XI.characters(newCharacters);
    return $lg2XI.shuffled();
}
/**
 * Generate unique id
 * Returns string id
 */ function $3a4b8eeb6e37bdc4$var$generate() {
    return $b39uO($3a4b8eeb6e37bdc4$var$clusterWorkerId);
}
// Export all other functions as properties of the generate function
module.exports = $3a4b8eeb6e37bdc4$var$generate;
module.exports.generate = $3a4b8eeb6e37bdc4$var$generate;
module.exports.seed = $3a4b8eeb6e37bdc4$var$seed;
module.exports.worker = $3a4b8eeb6e37bdc4$var$worker;
module.exports.characters = $3a4b8eeb6e37bdc4$var$characters;
module.exports.isValid = $73CeR;

});
parcelRegister("lg2XI", function(module, exports) {
"use strict";

var $c4JNH = parcelRequire("c4JNH");
var $f79d63d3c2665d02$var$ORIGINAL = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
var $f79d63d3c2665d02$var$alphabet;
var $f79d63d3c2665d02$var$previousSeed;
var $f79d63d3c2665d02$var$shuffled;
function $f79d63d3c2665d02$var$reset() {
    $f79d63d3c2665d02$var$shuffled = false;
}
function $f79d63d3c2665d02$var$setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if ($f79d63d3c2665d02$var$alphabet !== $f79d63d3c2665d02$var$ORIGINAL) {
            $f79d63d3c2665d02$var$alphabet = $f79d63d3c2665d02$var$ORIGINAL;
            $f79d63d3c2665d02$var$reset();
        }
        return;
    }
    if (_alphabet_ === $f79d63d3c2665d02$var$alphabet) return;
    if (_alphabet_.length !== $f79d63d3c2665d02$var$ORIGINAL.length) throw new Error("Custom alphabet for shortid must be " + $f79d63d3c2665d02$var$ORIGINAL.length + " unique characters. You submitted " + _alphabet_.length + " characters: " + _alphabet_);
    var unique = _alphabet_.split("").filter(function(item, ind, arr) {
        return ind !== arr.lastIndexOf(item);
    });
    if (unique.length) throw new Error("Custom alphabet for shortid must be " + $f79d63d3c2665d02$var$ORIGINAL.length + " unique characters. These characters were not unique: " + unique.join(", "));
    $f79d63d3c2665d02$var$alphabet = _alphabet_;
    $f79d63d3c2665d02$var$reset();
}
function $f79d63d3c2665d02$var$characters(_alphabet_) {
    $f79d63d3c2665d02$var$setCharacters(_alphabet_);
    return $f79d63d3c2665d02$var$alphabet;
}
function $f79d63d3c2665d02$var$setSeed(seed) {
    $c4JNH.seed(seed);
    if ($f79d63d3c2665d02$var$previousSeed !== seed) {
        $f79d63d3c2665d02$var$reset();
        $f79d63d3c2665d02$var$previousSeed = seed;
    }
}
function $f79d63d3c2665d02$var$shuffle() {
    if (!$f79d63d3c2665d02$var$alphabet) $f79d63d3c2665d02$var$setCharacters($f79d63d3c2665d02$var$ORIGINAL);
    var sourceArray = $f79d63d3c2665d02$var$alphabet.split("");
    var targetArray = [];
    var r = $c4JNH.nextValue();
    var characterIndex;
    while(sourceArray.length > 0){
        r = $c4JNH.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join("");
}
function $f79d63d3c2665d02$var$getShuffled() {
    if ($f79d63d3c2665d02$var$shuffled) return $f79d63d3c2665d02$var$shuffled;
    $f79d63d3c2665d02$var$shuffled = $f79d63d3c2665d02$var$shuffle();
    return $f79d63d3c2665d02$var$shuffled;
}
/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */ function $f79d63d3c2665d02$var$lookup(index) {
    var alphabetShuffled = $f79d63d3c2665d02$var$getShuffled();
    return alphabetShuffled[index];
}
function $f79d63d3c2665d02$var$get() {
    return $f79d63d3c2665d02$var$alphabet || $f79d63d3c2665d02$var$ORIGINAL;
}
module.exports = {
    get: $f79d63d3c2665d02$var$get,
    characters: $f79d63d3c2665d02$var$characters,
    seed: $f79d63d3c2665d02$var$setSeed,
    lookup: $f79d63d3c2665d02$var$lookup,
    shuffled: $f79d63d3c2665d02$var$getShuffled
};

});
parcelRegister("c4JNH", function(module, exports) {
"use strict";
// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
var $8ca962cdaa2663cc$var$seed = 1;
/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */ function $8ca962cdaa2663cc$var$getNextValue() {
    $8ca962cdaa2663cc$var$seed = ($8ca962cdaa2663cc$var$seed * 9301 + 49297) % 233280;
    return $8ca962cdaa2663cc$var$seed / 233280.0;
}
function $8ca962cdaa2663cc$var$setSeed(_seed_) {
    $8ca962cdaa2663cc$var$seed = _seed_;
}
module.exports = {
    nextValue: $8ca962cdaa2663cc$var$getNextValue,
    seed: $8ca962cdaa2663cc$var$setSeed
};

});


parcelRegister("b39uO", function(module, exports) {
"use strict";

var $7K5u5 = parcelRequire("7K5u5");
parcelRequire("lg2XI");
// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var $80b7573d5ecb91cf$var$REDUCE_TIME = 1567752802062;
// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var $80b7573d5ecb91cf$var$version = 7;
// Counter is used when shortid is called multiple times in one second.
var $80b7573d5ecb91cf$var$counter;
// Remember the last time shortid was called in case counter is needed.
var $80b7573d5ecb91cf$var$previousSeconds;
/**
 * Generate unique id
 * Returns string id
 */ function $80b7573d5ecb91cf$var$build(clusterWorkerId) {
    var str = "";
    var seconds = Math.floor((Date.now() - $80b7573d5ecb91cf$var$REDUCE_TIME) * 0.001);
    if (seconds === $80b7573d5ecb91cf$var$previousSeconds) $80b7573d5ecb91cf$var$counter++;
    else {
        $80b7573d5ecb91cf$var$counter = 0;
        $80b7573d5ecb91cf$var$previousSeconds = seconds;
    }
    str = str + $7K5u5($80b7573d5ecb91cf$var$version);
    str = str + $7K5u5(clusterWorkerId);
    if ($80b7573d5ecb91cf$var$counter > 0) str = str + $7K5u5($80b7573d5ecb91cf$var$counter);
    str = str + $7K5u5(seconds);
    return str;
}
module.exports = $80b7573d5ecb91cf$var$build;

});
parcelRegister("7K5u5", function(module, exports) {
"use strict";

var $lg2XI = parcelRequire("lg2XI");

var $bqW5i = parcelRequire("bqW5i");

var $k2nvx = parcelRequire("k2nvx");
function $5a311558079575bb$var$generate(number) {
    var loopCounter = 0;
    var done;
    var str = "";
    while(!done){
        str = str + $k2nvx($bqW5i, $lg2XI.get(), 1);
        done = number < Math.pow(16, loopCounter + 1);
        loopCounter++;
    }
    return str;
}
module.exports = $5a311558079575bb$var$generate;

});
parcelRegister("bqW5i", function(module, exports) {
"use strict";
var $852f2dc7733950f8$var$crypto = typeof window === "object" && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
var $852f2dc7733950f8$var$randomByte;
if (!$852f2dc7733950f8$var$crypto || !$852f2dc7733950f8$var$crypto.getRandomValues) $852f2dc7733950f8$var$randomByte = function randomByte(size) {
    var bytes = [];
    for(var i = 0; i < size; i++)bytes.push(Math.floor(Math.random() * 256));
    return bytes;
};
else $852f2dc7733950f8$var$randomByte = function randomByte(size) {
    return $852f2dc7733950f8$var$crypto.getRandomValues(new Uint8Array(size));
};
module.exports = $852f2dc7733950f8$var$randomByte;

});

parcelRegister("k2nvx", function(module, exports) {
// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.
module.exports = function(random, alphabet, size) {
    // We can’t use bytes bigger than the alphabet. To make bytes values closer
    // to the alphabet, we apply bitmask on them. We look for the closest
    // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
    // 30 symbols in the alphabet, we will take 31 (00011111).
    // We do not use faster Math.clz32, because it is not available in browsers.
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
    // which is bigger than the alphabet). As a result, we will need more bytes,
    // than ID size, because we will refuse bytes bigger than the alphabet.
    // Every hardware random generator call is costly,
    // because we need to wait for entropy collection. This is why often it will
    // be faster to ask for few extra bytes in advance, to avoid additional calls.
    // Here we calculate how many random bytes should we call in advance.
    // It depends on ID length, mask / alphabet size and magic number 1.6
    // (which was selected according benchmarks).
    // -~f => Math.ceil(f) if n is float number
    // -~i => i + 1 if n is integer number
    var step = -~(1.6 * mask * size / alphabet.length);
    var id = "";
    while(true){
        var bytes = random(step);
        // Compact alternative for `for (var i = 0; i < step; i++)`
        var i = step;
        while(i--){
            // If random byte is bigger than alphabet even after bitmask,
            // we refuse it by `|| ''`.
            id += alphabet[bytes[i] & mask] || "";
            // More compact than `id.length + 1 === size`
            if (id.length === +size) return id;
        }
    }
};

});



parcelRegister("73CeR", function(module, exports) {
"use strict";

var $lg2XI = parcelRequire("lg2XI");
function $523679a470c9eb99$var$isShortId(id) {
    if (!id || typeof id !== "string" || id.length < 6) return false;
    var nonAlphabetic = new RegExp("[^" + $lg2XI.get().replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&") + "]");
    return !nonAlphabetic.test(id);
}
module.exports = $523679a470c9eb99$var$isShortId;

});

parcelRegister("bo6AG", function(module, exports) {
"use strict";
module.exports = 0;

});




parcelRegister("fg5PJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1bce00a34de567f$var$expose;
function $b1bce00a34de567f$var$expose(funcName, func, opts) {
    opts = opts || {};
    var addListener = opts.addListener || window.addEventListener;
    var removeListener = opts.removeListener || window.removeEventListener;
    var postMessage = opts.postMessage || window.postMessage;
    var targetOrigin = opts.targetOrigin || "*";
    var getMessageData = opts.getMessageData || function(event) {
        return event.data;
    };
    var isCallback = opts.isCallback || false;
    var handler = function handler() {
        var data = getMessageData.apply(null, arguments);
        if (!data) return;
        if (data.sender !== "postmsg-rpc/client" || data.func !== funcName) return;
        var msg = {
            sender: "postmsg-rpc/server",
            id: data.id
        };
        var onSuccess = function onSuccess(res) {
            msg.res = res;
            postMessage(msg, targetOrigin);
        };
        var onError = function onError(err) {
            msg.err = Object.assign({
                message: err.message
            }, err.output && err.output.payload);
            postMessage(msg, targetOrigin);
        };
        if (isCallback) func.apply(null, data.args.concat(function(err, res) {
            if (err) return onError(err);
            onSuccess(res);
        }));
        else {
            var res = func.apply(null, data.args);
            Promise.resolve(res).then(onSuccess).catch(onError);
        }
    };
    addListener("message", handler);
    return {
        close: function close() {
            return removeListener("message", handler);
        }
    };
}

});




})();
//# sourceMappingURL=Entrypoint.bs.46283cdb.js.map
